import React, { useCallback, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { HomePage } from './homeStyle';
import Particles from 'react-tsparticles';
import { Engine } from 'tsparticles-engine';
import { loadStarsPreset } from 'tsparticles-preset-stars';
import { useState } from 'react';
import Animated from '../animatedLetters/Animated';
import { AnimatedLetter, AstroBtn, Bubble } from '../../utils/customStyles';

import spaceSvg from '../../assets/icons/24-sputnik.svg';

const Home = () => {
  // this customizes the component tsParticles installation
  const customInit = useCallback(async (engine: Engine) => {
    // this adds the bundle to tsParticles
    await loadStarsPreset(engine);
  }, []);

  const options = {
    detect_on: 'canvas',
    fpsLimit: 120,
    interactivity: {
      events: {
        onClick: {
          enable: true,
          mode: 'push',
        },
        onhover: {
          enable: true,
          mode: 'bubble',
        },
        resize: true,
      },
      modes: {
        grab: {
          distance: 400,
          links: {
            opacity: 1,
          },
        },
        push: {
          particles_nb: 4,
        },
        repulse: {
          distance: 200,
          duration: 0.4,
        },
      },
    },
    particles: {
      color: {
        value: '#ffffff',
      },
      links: {
        color: '#ffffff',
        distance: 150,
        enable: true,
        opacity: 0.4,
        width: 1,
      },
      collisions: {
        enable: true,
      },
      move: {
        enable: true,
        speed: 0.2,
        direction: 'none',
        random: true,
        straight: false,
        out_mode: 'out',
        bounce: false,
        attract: {
          enable: false,
          rotateX: 600,
          rotateY: 1200,
        },
      },
      number: {
        density: {
          enable: true,
          area: 800,
        },
        value: 150,
      },
      opacity: {
        value: 0.48927153781200905,
        random: false,
        anim: {
          enable: true,
          speed: 0.2,
          opacity_min: 0,
          sync: false,
        },
      },
      shape: {
        type: 'circle',
        stroke: {
          width: 0,
          color: '#000000',
        },
        polygon: {
          nb_sides: 5,
        },
      },
      size: {
        value: 2,
        random: true,
        anim: {
          enable: true,
          speed: 2,
          size_min: 0,
          sync: false,
        },
      },
    },
    detectRetina: true,
  };

  const [letters, setLetters] = useState('text-animate');

  useEffect(() => {
    setTimeout(() => {
      setLetters('text-animate-hover');
    }, 3500);
    // eslint-disable-next-line
  }, []);

  const nameArray = [
    ' ',
    'E',
    'm',
    'm',
    'a',
    'n',
    'u',
    'e',
    'l',
    ' ',
    ' ',
    'A',
    'g',
    'b',
    'a',
    ',',
  ];
  const roleArray = [
    'S',
    'o',
    'f',
    't',
    'w',
    'a',
    'r',
    'e',
    ' ',
    ' ',
    'e',
    'n',
    'g',
    'i',
    'n',
    'e',
    'e',
    'r',
    '.',
  ];

  return (
    <HomePage>
      <div className='solar-ring'></div>
      <div className='space-ship'>
        <img src={spaceSvg} alt='shuttle' />
      </div>
      <div className='text-zone'>
        <h1>
          <AnimatedLetter
            letterClass={letters}
            aria-hidden='true'
            delayCount={10}
          >
            H
          </AnimatedLetter>
          <AnimatedLetter
            letterClass={letters}
            aria-hidden='true'
            delayCount={11}
          >
            i
          </AnimatedLetter>
          <AnimatedLetter
            letterClass={letters}
            aria-hidden='true'
            delayCount={12}
          >
            ,
          </AnimatedLetter>
          <br />
          <AnimatedLetter
            letterClass={letters}
            aria-hidden='true'
            delayCount={13}
          >
            I
          </AnimatedLetter>
          <AnimatedLetter
            letterClass={letters}
            aria-hidden='true'
            delayCount={14}
          >
            '
          </AnimatedLetter>
          <AnimatedLetter
            letterClass={letters}
            aria-hidden='true'
            delayCount={15}
          >
            m
          </AnimatedLetter>
          <AnimatedLetter
            letterClass={letters}
            aria-hidden='true'
            delayCount={16}
          >
            {' '}
          </AnimatedLetter>

          <Animated letterClass={letters} strArray={nameArray} idx={17} />
          <br />
          <Animated letterClass={letters} strArray={roleArray} idx={34} />
        </h1>
        <h2>Fullstack Developer / JavaScript Expert / Freelancer</h2>
        <AstroBtn>
          <Link className='flat-button' to='/contact'>
            CONTACT ME
          </Link>
          <Bubble count={1}></Bubble>
          <Bubble count={2}></Bubble>
          <Bubble count={3}></Bubble>
          <Bubble count={4}></Bubble>
        </AstroBtn>
      </div>
      <Particles
        id='tsparticles'
        init={customInit}
        // loaded={particlesLoaded}
        options={options}
      />
    </HomePage>
  );
};

export default Home;
